import { RestError } from '@azure/core-http';
import * as _ from 'lodash';
import { Redirect } from 'react-router-dom';
import { useQueryListProjects } from '../../core/queries/projects.queries';
import { createPath, Paths } from './app.router';
import { sortProjectsByHierarchy } from '../../ui/components/pure/building-select/building-select.component';
// import { Layout } from '../layout/layout.component';
import { ErrorFullPage } from '../../ui/components/pure/errors/error-full-page/error-full-page.component';
import { internalProjectIDs } from './project.router';

export function NoProjectPage() {
  const { data, isLoading, error } = useQueryListProjects();

  if (error) {
    // js is not picking up the error as being an instance of RestError
    // Instead we are safely casting it as a RestError
    if ((error as RestError)?.statusCode === 401) {
      return <ErrorFullPage preset="GLOBAL_ACCESS_DENIED" />;
    }

    return <ErrorFullPage />;
  }

  if (!isLoading && _.isNil(data)) {
    return <ErrorFullPage />;
  }

  // If no errors, redirect the user to a project path
  if (!_.isNil(data) && data.length > 0) {
    const project = sortProjectsByHierarchy(data)[0];

    let redirectPath = Paths.dashboard;

    // Temporary hack to redirect users with a root project selected to the welcome page
    if (internalProjectIDs.includes(project.projectID)) {
      redirectPath = Paths.welcome;
    }

    return <Redirect to={createPath(redirectPath, { projectID: project.shortcode || project.projectID })} />;
  }

  return null;
}
